




















import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormFieldMixin from '@/mixins/registration/FormFieldMixin';
import RequiredFieldValidator from './validation/RequiredFieldValidator.vue';

@Component({
  components: { RequiredFieldValidator }
})
export default class FormTextArea extends Mixins(FormFieldMixin) {
  @Prop({ default: 4 }) readonly rows!: number;
  @Prop() readonly value!: string;

  $refs!: {
    inputElement: HTMLFormElement;
  };

  public focusInput (): void {
    this.$refs.inputElement.focus();
  }

  public hasValue (): boolean {
    return this.value !== undefined && this.value !== null && this.value !== '';
  }
}
